import IntlMessage from '../../util/IntlMessage';
import * as React from 'react';

interface ProfileSecurityFormErrors {
    confirmPassword?: string | Array<string | React.ReactElement | Element | Function>;
    newPassword?: string | Array<string | React.ReactElement | Element | Function>;
}

export const securityFormValidation = (values: ProfileSecurityFormValues) => {
    const errors: ProfileSecurityFormErrors = {};

    if (values.newPassword && values.newPassword.length < 6) {
        errors.newPassword = [<IntlMessage key='too-short' id='profile.security.validation.password_too_short' />];
    }

    if (values.confirmPassword !== values.newPassword) {
        errors.confirmPassword = [<IntlMessage key='not-same' id='profile.security.validation.password_not_same' />];
    }

    return errors;
};
